module.exports = __webpack_public_path__ + "media/assets/icons/teenyicons_arrow-down-outline-f8527bea5479f9f14fb9b8af3036e0c8.svg";